import request from "@/utils/request";

const index = () => request
  .get("/api/categories");

const withBookList = () => request
  .get("/api/categories?includes=book_list");

export default {
  index,
  withBookList
};
